module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hr', {
    staticClass: "lumi-divider"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-b63e7f8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LumiDivider.vue
// module id = 71
// module chunks = 0